import { BUSINESS_PAYMENT_PREFIX, GetAutoReportFieldType } from '@oy/types';
import axios from 'src/clients/axios';

export const GET_AUTO_REPORT_FIELD = `${BUSINESS_PAYMENT_PREFIX}/auto-report/product/field`;

export const getAutoReportField = (product_name: string) => {
  return axios.get<GetAutoReportFieldType>(GET_AUTO_REPORT_FIELD, {
    params: { product_name },
  });
};
